import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import config from '../config';

const options = {
  apiKey: config.bugsnag.apiKey,
  releaseStage: config.mode === 'PROD' ? 'production' : 'development',
  appVersion: config.bugsnag.appVersion,
  plugins: [new BugsnagPluginReact()],
};

const bugsnagClient = Bugsnag.start(options);

export default bugsnagClient;
